import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import usePlatform from '@/utils/hooks/usePlatform';

/**
 * Reusable split-view layout: sidebar + main content side-by-side on web.
 * On native, only children (main content) are rendered — the sidebar list
 * is shown on the previous screen via stack navigation.
 *
 * @param {React.ReactNode} sidebar  — list panel (boards, conversations, etc.)
 * @param {React.ReactNode} children — main content (detail view)
 * @param {object} style — optional style override for the outer container
 */
const SplitView = ({ sidebar, children, style }) => {
    const { isWeb } = usePlatform();

    if(!isWeb) {
        return <>{children}</>;
    }

    return (
        <View style={[styles.container, style]}>
            <View style={styles.sidebar}>
                {sidebar}
            </View>
            <View style={styles.main}>
                {children}
            </View>
        </View>
    );
};

const styles = StyleSheet.create(({ colors }) => ({
    container: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: 'transparent',
    },
    sidebar: {
        width: 320,
        maxWidth: '30%',
        borderRightWidth: 1,
        borderRightColor: colors.border,
        backgroundColor: colors.background,
    },
    main: {
        flex: 1,
    },
}));

export default SplitView;
